import React from 'react';
import { useEffect } from 'react';
import { connect } from 'react-redux'
import HeaderAlertModel from '../../store/HeaderAlert/HeaderAlertModel';
import './HeaderAlert.scss';
import { actAlertClose } from '../../store/Actions';

interface OwnProps { }
interface DispatchProps { alertClose: any }
interface StateProps { conf: HeaderAlertModel }
type Props = OwnProps & StateProps & DispatchProps

let closeTimer: any = null;

function HeaderAlert(props: Props) {
    useEffect(() => {
        if (props.conf.timeoutSeconds > 0) {
            if (closeTimer) {
                clearTimeout(closeTimer);
            }
            closeTimer = setTimeout(() => {
                onCloseClick();
            }, props.conf.timeoutSeconds * 1000);
        }
    });

    function onCloseClick() {
        props.alertClose();
    }

    if (!props.conf.show) return <></>;
    return (
        <div className={'header-alert alert alert-' + props.conf.type}>
            {props.conf.text}
            <button type="button" className="close" data-dismiss="alert" onClick={onCloseClick}>
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
    );
}
const mapStateToProps = (state: any) => {
    return { conf: state.alert }
}
const mapDispatchToProps = (dispatch: any) => {
    return {
        alertClose: () => { actAlertClose(dispatch) }
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(HeaderAlert)

